import { useMemo } from "react";
import BalanceContext from "../context/BalanceContext";
import SymbolInputContext from "../context/SymbolInputContext";
import RestakeTabContext from "../context/RestakeTabContext";

const { useBalanceTracked } = BalanceContext;
const { useSymbolInputTracked } = SymbolInputContext;
const { useRestakeTabTracked } = RestakeTabContext;

function useShownBalance() {
  const [balance] = useBalanceTracked();
  const [symbolInput] = useSymbolInputTracked();
  const [tab] = useRestakeTabTracked();
  const shownBalance = useMemo(() => {
    if (tab === "deposit") return balance[symbolInput.address]?.tokenBalance;
    else if (tab === "unstake")
      return balance[symbolInput.address]?.stakedToken;
    else return;
  }, [symbolInput, balance, tab]);
  return shownBalance;
}

export default useShownBalance;
